/**
 * ApiErrorNotifier
 * React component that bridges the API error event system with the Toast UI.
 * Place this inside the ToastProvider in App.js.
 */

import { useEffect, useRef } from 'react';
import { useToast } from './ui/Toast';
import { apiErrorEvents } from '../utils/apiErrorHandler';

// Deduplicate rapid-fire toasts: suppress identical titles within 3 seconds
const TOAST_DEDUP_MS = 3000;

const ApiErrorNotifier = () => {
  const toast = useToast();
  const recentToasts = useRef(new Map()); // title -> timestamp

  useEffect(() => {
    const unsubscribe = apiErrorEvents.subscribe((error) => {
      const now = Date.now();
      const key = error.title || error.message;
      const lastShown = recentToasts.current.get(key) || 0;

      if (now - lastShown < TOAST_DEDUP_MS) {
        return; // suppress duplicate
      }

      recentToasts.current.set(key, now);
      toast.show({
        type: error.type || 'error',
        title: error.title,
        message: error.message,
      });
    });

    return unsubscribe;
  }, [toast]);

  return null; // This component renders nothing
};

export default ApiErrorNotifier;
